import { IconCollection } from "components/Icon/IconCollection";

export interface ReadToggleAction {
    icon: (typeof IconCollection)["eyeOutline"];
    title: string;
    ariaLabel: string;
    // The read-state to write when the control is clicked.
    nextRead: boolean;
}

// Maps a comment's current read-state to the read-toggle icon action shown on
// it. An unread comment offers "Mark read" (open-eye icon) and writes read=true;
// an already-read comment offers "Mark unread" (eye-off icon) and writes
// read=false. The icon reflects the resulting state and the tooltip/aria-label
// names the action, so the icon-only control stays unambiguous
// (ui-design-principle-affordance-interactivity).
export const readToggleAction = (isUnread: boolean): ReadToggleAction =>
    isUnread
        ? {
              icon: IconCollection.eyeOutline,
              title: "Mark read",
              ariaLabel: "Mark read",
              nextRead: true,
          }
        : {
              icon: IconCollection.eyeOffOutline,
              title: "Mark unread",
              ariaLabel: "Mark unread",
              nextRead: false,
          };
